import React from 'react';
import { Link } from 'react-router-dom';
import { reviews } from '../../data/reviews';
import { getProduct } from '../../utils/products';
import { Stars } from '../shop/Stars';
import { Reveal } from '../ui/Reveal';
export function ReviewsSection() {
  return <section className="mx-auto grid max-w-7xl gap-12 px-5 py-20 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-28" data-id="element-107" data-mp="1ayo99qvxbagj">
      <Reveal className="lg:col-span-4" data-id="element-108" data-mp="23pg4om55zv2t">
        <p className="font-display text-[7rem] leading-none tracking-display text-berry sm:text-[9rem]" data-id="element-109" data-mp="23oeroc4l8yig">4,8</p>
        <div className="mt-3" data-id="element-110" data-mp="1yrobzpwp44xk">
          <Stars rating={4.8} size="md" data-id="element-111" data-mp="1yoadisr5kfve" />
        </div>
        <p className="mt-2 text-muted" data-id="element-112" data-mp="1tq8to5lwkciv">uit 3.100+ geverifieerde reviews</p>
      </Reveal>
      <ul className="lg:col-span-8" data-id="element-113" data-mp="1osysjsp5icf7">
        {reviews.map((r, i) => {
        const p = getProduct(r.product);
        return <li key={r.name} className="border-t border-line py-8 first:border-t-0 first:pt-0 lg:first:pt-4" data-id="element-114" data-mp="idepl1c0kq9d" data-mpi={i}>
              <Reveal delay={i * 0.05} data-id="element-115" data-mp="df4suman5hln">
                <p className="text-2xl font-medium leading-snug tracking-tight text-ink sm:text-3xl" data-id="element-116" data-mp="17pqukd5ljouv">“{r.text}”</p>
                <div className="mt-4 flex items-center gap-3 text-sm" data-id="element-117" data-mp="1cobtm99442hq">
                  <span className="font-medium" data-id="element-118" data-mp="xscn331niaep">{r.name}</span>
                  <span className="text-line" data-id="element-119" data-mp="xrugbchd4dsj">—</span>
                  {p && <Link to={`/product/${p.slug}`} className="text-muted underline underline-offset-4 hover:text-ink" data-id="element-120" data-mp="12pm9saxno7yu">
                      {p.name}
                    </Link>}
                </div>
              </Reveal>
            </li>;
      })}
      </ul>
    </section>;
}